import { Scene, Choice, Dialog } from "../models";
import { scenes } from "../scenes";

const openDoor = [
  new Dialog(
    "[You unlock the door]",
    require("@/images/Key_in_Door.png"),
    require("@/audio/Found_Jingle.mp3")
  ),
];
export class FrontDoor extends Scene {
  title = "Dareth's Front Door";

  async init() {
    this.image = require("@/images/Dareths_Front_Door.png");
    if (this.state.inventory.key.has) {
    } else {
      this.audio = require("@/audio/Pandemic-49-Sonny-MP3.mp3");
      this.description =
        "SONNY YANG: It appears the door is LOCKED. I’d wager that Dareth Schamren might have a SPARE KEY hiding around somewhere…";
    }
  }

  get options(): any[] {
    return [
      new Choice("Open Door", async () => {
        if (this.state.inventory.key.has) {
          await this.dialogRunner(openDoor)
          await this.navigate(scenes.DarethsFoyer())
        } else {
          this.description = "[The door is locked]";
          this.audio = null;
        }
      }),
      new Choice("Ring Doorbell", () => {
        this.description = "SONNY YANG: Hmm no response.";
        this.audio = require("@/audio/Pandemic-48-Sonny-MP3.mp3");
      }),
      new Choice("Go Back", async () => await this.navigate(scenes.DarethsYard())),
    ];
  }
}
export default new FrontDoor();
